<template>
    <div class="p-3 text-center">
        <div class="bg-light py-4 rounded">
            <div class="d-flex align-items-center justify-content-center">
                <font-awesome-icon
                    icon="fa-duotone fa-coin"
                    size="lg"
                    class="small-avatar mr-2 text-warning"
                />
                <h3 v-if="subscriptionPrice" class="text-warning mb-0">
                    {{ subscriptionPrice }}
                    {{ $t("credits") }}
                </h3>
            </div>

            <div class="text-secondary">
                {{ $t("per week") }}
            </div>

            <div class="small text-success mt-3">
                <font-awesome-icon icon="fa-duotone fa-shield-check" />
                {{ $t("Your card will NEVER be charged automatically") }}
            </div>
        </div>

        <creator-subscription-pricing class="mt-3" />

        <div class="mt-2 text-left">
            <div class="small text-secondary my-1">
                <font-awesome-icon
                    icon="fa-light fa-check"
                    class="text-success"
                />
                {{ $t("Cancel anytime") }}
            </div>
            <div class="small text-secondary my-1">
                <font-awesome-icon
                    icon="fa-light fa-check"
                    class="text-success"
                />
                {{ $t("Paid from your wallet balance every week") }}
            </div>
            <div class="small text-secondary my-1">
                <font-awesome-icon
                    icon="fa-light fa-check"
                    class="text-success"
                />
                {{ $t("View all of their private content") }}
            </div>
        </div>

        <div class="branded my-3 text-center">
            <font-awesome-icon icon="fa-light fa-arrow-down" size="2x" />
        </div>

        <div class="mt-3">
            <b-btn
                :disabled="saving"
                v-if="canSubscribe"
                @click="createSubscription"
                variant="primary"
                size="lg"
                block
                pill
            >
                {{ $t("Subscribe") }}
            </b-btn>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

import CreatorSubscriptionPricing from "@/components/creator/creatorSubscription/CreatorSubscriptionPricing";

export default {
    data() {
        return {
            saving: false,
        };
    },
    computed: {
        modal: {
            get() {
                return this.$store.state.interface
                    .creatorSubscriptionModalVisible;
            },
            set(value) {
                this.$store.commit(
                    "interface/setCreatorSubscriptionModalVisible",
                    value
                );
            },
        },
        ...mapState("creatorSubscription", [
            "subscriptionPrice",
            "creatorUserId",
            "creatorPostId",
            "creatorGalleryId",
        ]),
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
        canSubscribe() {
            return this.creatorUserId !== this.onboardingUser.id;
        },
    },
    methods: {
        createSubscription() {
            this.saving = true;

            this.api
                .post("/subscription/create", {
                    creatorPostId: this.creatorPostId,
                    // these are both optional, kinda swizzle-esque
                    creatorUserId: this.creatorUserId,
                    creatorGalleryId: this.creatorGalleryId,
                })
                .then(() => {
                    this.$store.dispatch("onboarding/status");

                    this.$store.commit(
                        "interface/setCreatorSubscriptionModalVisible",
                        false
                    );
                })
                .finally(() => {
                    this.saving = false;
                });
        },
    },
    components: {
        CreatorSubscriptionPricing,
    },
};
</script>